// native
import { Directive, TemplateRef } from '@angular/core';

/** Marks the template used to render a body cell. Context: `$implicit = dataItem`. */
@Directive({
    selector: '[appGridCellTemplate]',
    standalone: false
})
export class DataGridCellTemplateDirective {
  constructor(public templateRef: TemplateRef<unknown>) { }
}

/** Marks the template used to render a column's filter cell. Context: `$implicit = filter`, `column`. */
@Directive({
    selector: '[appGridFilterCellTemplate]',
    standalone: false
})
export class DataGridFilterCellTemplateDirective {
  constructor(public templateRef: TemplateRef<unknown>) { }
}
